/*
Suresh Peddavoora 12/16/2022 2701127043 Modified Styles in Dialog Box, removed Inline Styles
Sai Maheshwar 12/16/2022 2701127043 add accordion for function usage
Suresh Peddavoora 12/16/2022 2701127043 Fixed Button Alignments, Added Class Name for Function usage Accordion
Raghu 12/18/2022 2701127043 Added new data fields
Sai Maheshwar 12/18/2022 2701012930 Added code and returnType
dilip 12/20/2022 2701012930 Added operators dropdown
Sohel 12/22/2022 3075220937 rename Function Usage
akhila 12/22/2022 3075220937 set default value for operators
Sai Maheshwar 12/23/2022 2701012930 added table column name for insert
dilip 01/03/2023 2701012930 Changed fields option label.
Akhila 01/06/2023 2701012930 Added return Type Static data in function usage
Akhila 01/18/2023 2701012930 bug fixed page break issue
Akhila 01/19/2023 2701012930 Validation issue on reset bug fixed
Akhila 01/31/2023 2701012930 Modified Unsaved Changes alert popup
Raghu 02/21/2023 2701012930 changed buttons color
suresh peddavoora 03/13/2023 2701012930 font-family styles added
Prakash 24/04/2023 2701012930 fixed alignment issue for input filed
Prakash 9/05/2023 2701012930 add theming classname
Prakash 16/05/2023 2701012930 Fixed specing issue in tab view
Sohel 10/16/2023 2701012930 Fields Dropdown value Changes
*/
import { Button, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { fetchFunctionDetailsById } from '../../../../../../redux/reducers/BRE/AddRuleGroup';
import { ThemeContext } from '../../../../../../themes/ThemeProvider';
import AddRuleSelectField from './AddRuleSelectField';
import { httpPost } from '../../../../../../util/Rest';
import PageLoader from '../../../../../../components/PageLoader';
import './styles.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '600',
    fontFamily: 'articulate,san-serif !important',
  },
}));

const AddRule = ({
  setOpen,
  fieldCode,
  formData,
  setFormData,
  rowData,
  isEditMode,
  oldRuleCode,
  onReset,
  setIsEditMode,
  ruleGroupSNo,
  setFieldCode,
  handleClose,
  handleDirty,
}) => {
  const classes1 = useStyles();
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const {
    allFunctions = [],
    formulaFieldsData,
    functionDetails,
    basicInfoData,
    operatorsDropdownData,
  } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const selectedFormulaType = basicInfoData?.formulaType;

  const dispatch = useDispatch();
  const expressionRef = useRef();
  const initialVal = {
    function: null,
    expression: '',
    operators: null,
  };

  const [initialValues, setInitialValues] = useState(initialVal);

  useEffect(() => {
    if (allFunctions && allFunctions.length > 0) {
      const initialValues = {
        ruleCode: isEditMode
          ? rowData && rowData.ruleCode
          : ruleGroupSNo
            ? ruleGroupSNo > 9
              ? 'F' + ruleGroupSNo
              : 'F' + ruleGroupSNo
            : isEditMode && rowData && rowData.ruleCode
              ? rowData.ruleCode
              : '',
        // returnType: isEditMode && rowData && rowData.returnType ? rowData.returnType : "",
        expression: isEditMode && rowData && rowData.expression ? rowData.expression : '',
      };
      setInitialValues((prev) => ({ ...prev, ...initialValues, function: allFunctions[0] }));
      dispatch(fetchFunctionDetailsById(allFunctions[0].dataCalculationFunctionId));
    }
  }, [allFunctions]);
  useEffect(() => {
    if (operatorsDropdownData && operatorsDropdownData.length > 0) {
      setInitialValues((prev) => ({ ...prev, operators: operatorsDropdownData[0] }));
    }
  }, [operatorsDropdownData]);
  const handleCheckSyntax = (values) => {
    if (values?.expression?.trim()) {
      setIsLoading(true);
      const payload = {
        ruleExpression: values?.expression?.trim(),
        returnType: basicInfoData?.returnType,
        code: basicInfoData?.code,
        formulaType: basicInfoData?.formulaType,
        formulaRuleGroupId: basicInfoData?.groupId,
      };
      httpPost(`rules/validate/rule`, payload)
        .then((response) => {
          if (response?.data?.status === 400) {
            setIsLoading(false);
            setErrorMessage(response?.data?.message);
            setSuccessMessage(null);
          } else if (response?.status === 200) {
            setIsLoading(false);
            // setIsDelete(false);
            // setStatus(true);

            setSuccessMessage(response?.response);
            // handleSubmission({...values, formulaExpression: response?.response});
            setErrorMessage(null);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrorMessage(error);
        });
    }
  };

  const handleSubmission = (values) => {
    const data = { ...values };
    const copyData = [...formData];

    if (!isEditMode) {
      copyData.push({
        ...data,
        expression: values.expression?.trim(),
        tableData: { checked: true },
      });
      setFormData(copyData);
      setOpen(false);
    } else {
      const updatedData = copyData.map((each) => {
        if (each.ruleCode === oldRuleCode) {
          return {
            ...each,
            ruleCode: data.ruleCode,
            returnType: basicInfoData?.returnType,
            expression: values?.expression?.trim(),
            // fieldListCode: basicInfoData?.formulaType === "Create Constant" ? "" : basicInfoData?.fieldListCode,
            formulaType: basicInfoData?.formulaType,
            formulaExpression: data?.formulaExpression ? data?.formulaExpression : '',
          };
        } else {
          return { ...each };
        }
      });
      setFormData(updatedData);
      setOpen(false);
      setIsEditMode(false);
    }
  };

  const handleSubmit = (values) => {
    if (values) {
      handleSubmission({ ...values, formulaExpression: successMessage });
    }
    handleDirty(true);
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
      {(props) => {
        const { values, handleChange, setFieldValue, resetForm } = props;
        return (
          <Form>
            <div
              style={{
                // display: "flex",
                padding: '0rem 1.8rem',
              }}
            >
              <div className="d-flex mb-3 calculation-rule-fields">
                <div className="mr-2">
                  <span className="fields-title">Calculation Name :</span>{' '}
                  <span className="fields-value">
                    {basicInfoData?.code?.replace(/ /g, '\u00a0')}
                  </span>
                </div>
                <div>
                  <span className="fields-title">Return Type :</span>{' '}
                  <span className="fields-value">{basicInfoData?.returnType}</span>
                </div>
              </div>
              <div className="row">
                <AddRuleSelectField
                  label={'Functions'}
                  options={allFunctions}
                  value={values.function}
                  name="function"
                  placeholder="Select Function"
                  handleChange={(_, value) => {
                    setFieldValue('function', value);
                    if (value?.dataCalculationFunctionId) {
                      dispatch(fetchFunctionDetailsById(value?.dataCalculationFunctionId));
                    }
                    // const handleFieldCode = (code, values, setFieldValue) => {
                    //   let cursorPosition = expressionRef.current.selectionStart;
                    //   const getCode = value.functionName;
                    //   console.log(values.expression, cursorPosition, "ex");
                    //   if (values.expression) {
                    //     setFieldValue("expression", getCode);
                    //   } else {
                    //     setFieldValue(
                    //       "expression",
                    //       values.expression.slice(0, cursorPosition) +
                    //         getCode +
                    //         values.expression.slice(cursorPosition)
                    //     );
                    //     expressionRef.current.focus();
                    //   }
                    //   setFieldValue(
                    //     "expression",
                    //     values.expression.slice(0, cursorPosition) +
                    //       getCode +
                    //       values.expression.slice(cursorPosition)
                    //   );
                    //   expressionRef.current.focus();
                    //   };
                  }}
                  handleInsert={() => {
                    const selectedFunc = functionDetails?.syntax;
                    const cursorPosition = expressionRef.current.selectionStart;
                    if (values.expression) {
                      setFieldValue(
                        'expression',
                        values.expression.slice(0, cursorPosition) +
                          selectedFunc +
                          values.expression.slice(cursorPosition),
                      );
                      expressionRef.current.focus();
                    } else {
                      setFieldValue('expression', selectedFunc);
                    }
                  }}
                  optionLable={(option) => option.functionName}
                />
                {selectedFormulaType !== 'Create Constant' && (
                  <AddRuleSelectField
                    label={'Fields'}
                    options={formulaFieldsData}
                    optionLable={(option) => option?.repositoryName + '.' + option.fieldName}
                    handleChange={(_, value) => {
                      setFieldValue('fields', value);
                    }}
                    placeholder="Select Field"
                    handleInsert={() => {
                      const selectedFunc = values?.fields?.repositoryName
                        ? `${values?.fields?.repositoryName}.${values?.fields?.fieldName}`
                        : '';
                      const cursorPosition = expressionRef.current.selectionStart;
                      if (values.expression) {
                        setFieldValue(
                          'expression',
                          values.expression.slice(0, cursorPosition) +
                            selectedFunc +
                            values.expression.slice(cursorPosition),
                        );
                        expressionRef.current.focus();
                      } else {
                        setFieldValue('expression', selectedFunc);
                      }
                    }}
                  />
                )}

                <AddRuleSelectField
                  label="Operators"
                  options={operatorsDropdownData || []}
                  optionLable={(option) => `${option?.valueCode || ''} ${option?.value || ''}`}
                  handleChange={(_, value) => {
                    setFieldValue('operators', value);
                  }}
                  placeholder="Select Operator"
                  value={values.operators}
                  handleInsert={() => {
                    const selectedFunc = values?.operators?.valueCode
                      ? `${values?.operators?.valueCode}`
                      : '';
                    const cursorPosition = expressionRef.current.selectionStart;
                    if (values.expression) {
                      setFieldValue(
                        'expression',
                        values.expression.slice(0, cursorPosition) +
                          selectedFunc +
                          values.expression.slice(cursorPosition),
                      );
                      expressionRef.current.focus();
                    } else {
                      setFieldValue('expression', selectedFunc);
                    }
                  }}
                />
              </div>

              {functionDetails && 'functionName' in functionDetails && (
                <Accordion className="accordion-styling function-usage-accordion calculation-accordion">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes1.heading}>Function Usage Help</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="function-usage">
                      <p>
                        <span>Function:</span>
                        {functionDetails?.functionName}
                      </p>
                      <p>
                        <span>Description:</span> {functionDetails?.description}
                      </p>
                      <p>
                        <span>Syntax:</span> {functionDetails?.syntax}
                      </p>
                      <p>
                        <span>Example:</span> {functionDetails?.example}
                      </p>
                      <p>
                        <span>Return Type:</span> {functionDetails?.returnType}
                      </p>
                    </div>
                  </AccordionDetails>
                </Accordion>
              )}

              <div className="expression-textfield new-standard-textfields reportout-filed">
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder={`Enter Expression`}
                  className={` ${classes.labelName}`}
                  label="Expression"
                  multiline
                  minRows={2}
                  maxRows={2}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  name="expression"
                  required
                  value={values.expression}
                  onChange={(e) => {
                    //   setExpression(e?.target?.value);
                    setErrorMessage(null);
                    setSuccessMessage(null);
                    handleChange(e);
                  }}
                  // onBlur={handleBlur}
                  inputRef={expressionRef}
                  fullWidth
                  // touched={touched.expression}
                  // error={Boolean(touched.expression && errors.expression)}
                />
              </div>
              <>
                {errorMessage && <div className="error-text">{errorMessage}</div>}
                {successMessage && <div className="success-text">Expression is valid</div>}
              </>
              <div className=" d-flex justify-content-between new-standard-textfields mt-3">
                <div>
                  <Button
                    variant="outlined"
                    type="button"
                    className={`search-btn ${classes.buttonRoot}  mt-2`}
                    onClick={() => handleCheckSyntax(values)}
                  >
                    Check syntax
                  </Button>
                </div>
                <div className=" new-standard-textfields my-2">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      resetForm(initialValues);
                      setErrorMessage(null);
                      setSuccessMessage(null);
                    }}
                    className={`reset-btn mx-1 ${classes.buttonRoot}`}
                  >
                    Reset
                  </Button>
                  {successMessage ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot} `}
                    >
                      Save
                    </Button>
                  ) : (
                    <Tooltip title="Please check syntax before saving">
                      <span>
                        <Button
                          variant="outlined"
                          disabled={true}
                          className={`search-btn mx-1 ${classes.buttonRoot} `}
                        >
                          Save
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </div>
                <div> </div>
              </div>
            </div>
            {isLoading && <PageLoader />}
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddRule;
